import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, tap} from 'rxjs/operators';
import {AuthService} from './auth.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {defaultError} from '../modules/share/utils/constants';
import {Router} from '@angular/router';
import {LoadingService} from "./loading.service";
import {DebugLogService} from "./debug-log.service";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private router: Router,
    private loadingService: LoadingService,
    private debugLogService: DebugLogService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.token;
    request = token
      ? request.clone({headers: request.headers.set('sso', token)})
      : request.clone({withCredentials: true});

    this.loadingService.show();

    const requestHeaders: Record<string, string> = {};
    request.headers.keys().forEach(key => requestHeaders[key] = request.headers.get(key));
    const logId = this.debugLogService.logRequest(request.method, request.urlWithParams, requestHeaders, request.body);

    return next.handle(request).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.loadingService.hide();
            this.debugLogService.completeRequest(logId, event.status, event.statusText, event.body);
          }
        }),
        catchError((err: any) => {
          this.loadingService.hide();
          this.debugLogService.failRequest(logId, err);
          switch (err.status) {
            case 500:
              this.toastrService.error(this.translateService.instant('Errors.Service temporarily unavailable, try again later'));
              break;
            case 401:
              this.toastrService.error(this.translateService.instant('Errors.Session expired'));
              console.log('this.authService.isDeviceMobile',this.authService.isDeviceMobile)
              // this.authService.isDeviceMobile ? window.mobapp.onBackNavigation() : this.authService.logout();
              break;
            default:
              // Handle other statuses if necessary
          }
          const error = (err.error && err.error.message) || err.statusText;
          return throwError(err);
        }),
        finalize(() => {
          // Hide the loading spinner after the response or error
          this.loadingService.hide();
        })
    );
  }

}
